import { render, staticRenderFns } from "./DetailNotifications.vue?vue&type=template&id=14dbfe3a"
import script from "../../script/notifications/detailNotifications.js?vue&type=script&lang=js&external"
export * from "../../script/notifications/detailNotifications.js?vue&type=script&lang=js&external"
import style0 from "../../less/notifications/detailNotifications.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports